const names = [
  {
    id: 0,
    name: "Zahra",
    sex: "f",
  },
  {
    id: 1,
    name: "Parsa",
    sex: "m",
  },
  {
    id: 2,
    name: "Avah",
    sex: "f",
  },
  {
    id: 3,
    name: "Lala",
    sex: "f",
  },
  {
    id: 4,
    name: "Jamshed",
    sex: "m",
  },
  {
    id: 5,
    name: "Yasir",
    sex: "m",
  },
  {
    id: 6,
    name: "Damiya",
    sex: "f",
  },
  {
    id: 7,
    name: "Abbas",
    sex: "m",
  },
  {
    id: 8,
    name: "Sahar",
    sex: "f",
  },
  {
    id: 9,
    name: "Neo",
    sex: "m",
  },
  {
    id: 10,
    name: "Damali",
    sex: "f",
  },
  {
    id: 11,
    name: "Olajuwon",
    sex: "m",
  },
  {
    id: 12,
    name: "Elinda",
    sex: "f",
  },
  {
    id: 13,
    name: "Emoni",
    sex: "f",
  },
  {
    id: 14,
    name: "Nabil",
    sex: "m",
  },
  {
    id: 15,
    name: "Kheri",
    sex: "f",
  },
  {
    id: 16,
    name: "Kidus",
    sex: "m",
  },
  {
    id: 17,
    name: "Aiyana",
    sex: "f",
  },
  {
    id: 18,
    name: "Ayana",
    sex: "f",
  },
  {
    id: 19,
    name: "Makoa",
    sex: "m",
  },
  {
    id: 20,
    name: "Cyrus",
    sex: "m",
  },
  {
    id: 21,
    name: "Mina",
    sex: "f",
  },
  {
    id: 22,
    name: "Zia",
    sex: "f",
  },
  {
    id: 23,
    name: "Roshan",
    sex: "m",
  },
  {
    id: 24,
    name: "Taja",
    sex: "f",
  },
  {
    id: 25,
    name: "Naveed",
    sex: "m",
  },
  {
    id: 26,
    name: "Suri",
    sex: "f",
  },
  {
    id: 27,
    name: "Farah",
    sex: "f",
  },
  {
    id: 28,
    name: "Shirin",
    sex: "f",
  },
  {
    id: 29,
    name: "Navid",
    sex: "m",
  },
  {
    id: 30,
    name: "Azra",
    sex: "f",
  },
  {
    id: 31,
    name: "Adonai",
    sex: "m",
  },
  {
    id: 32,
    name: "Livna",
    sex: "f",
  },
  {
    id: 33,
    name: "Sheran",
    sex: "f",
  },
  {
    id: 34,
    name: "Mayar",
    sex: "f",
  },
  {
    id: 35,
    name: "Magdalene",
    sex: "f",
  },
  {
    id: 36,
    name: "Areli",
    sex: "f",
  },
  {
    id: 37,
    name: "Or",
    sex: "m",
  },
  {
    id: 38,
    name: "Josiah",
    sex: "m",
  },
  {
    id: 39,
    name: "Zetta",
    sex: "f",
  },
  {
    id: 40,
    name: "Rohin",
    sex: "m",
  },
  {
    id: 41,
    name: "Vilas",
    sex: "m",
  },
  {
    id: 42,
    name: "Isha",
    sex: "f",
  },
  {
    id: 43,
    name: "Shlok",
    sex: "m",
  },
  {
    id: 44,
    name: "Setia",
    sex: "f",
  },
  {
    id: 45,
    name: "Surya",
    sex: "m",
  },
  {
    id: 46,
    name: "Arushi",
    sex: "f",
  },
  {
    id: 47,
    name: "Aditi",
    sex: "f",
  },
  {
    id: 48,
    name: "Rachana",
    sex: "f",
  },
  {
    id: 49,
    name: "Vadhir",
    sex: "m",
  },
  {
    id: 50,
    name: "Mohammad",
    sex: "m",
  },
  {
    id: 51,
    name: "Shaan",
    sex: "m",
  },
  {
    id: 52,
    name: "Arathi",
    sex: "m",
  },
  {
    id: 53,
    name: "Ashwin",
    sex: "m",
  },
  {
    id: 54,
    name: "Rudra",
    sex: "m",
  },
  {
    id: 55,
    name: "Loma",
    sex: "f",
  },
  {
    id: 56,
    name: "Patrick",
    sex: "m",
  },
  {
    id: 57,
    name: "Sriram",
    sex: "m",
  },
  {
    id: 58,
    name: "Aayan",
    sex: "m",
  },
  {
    id: 59,
    name: "Shakila",
    sex: "f",
  },
  {
    id: 60,
    name: "Iran",
    sex: "m",
  },
  {
    id: 62,
    name: "Dara",
    sex: "f",
  },
  {
    id: 63,
    name: "Jama",
    sex: "f",
  },
  {
    id: 64,
    name: "Yasmina",
    sex: "f",
  },
  {
    id: 65,
    name: "Mikah",
    sex: "m",
  },
  {
    id: 66,
    name: "Aram",
    sex: "m",
  },
  {
    id: 67,
    name: "Arash",
    sex: "m",
  },
  {
    id: 69,
    name: "Aashi",
    sex: "f",
  },
  {
    id: 70,
    name: "Zamir",
    sex: "m",
  },
  {
    id: 71,
    name: "Mostafa",
    sex: "m",
  },
  {
    id: 72,
    name: "Yasin",
    sex: "m",
  },
  {
    id: 73,
    name: "Zaki",
    sex: "m",
  },
  {
    id: 74,
    name: "Ammar",
    sex: "m",
  },
  {
    id: 76,
    name: "An",
    sex: "f",
  },
  {
    id: 77,
    name: "Shira",
    sex: "f",
  },
  {
    id: 78,
    name: "Yaron",
    sex: "m",
  },
  {
    id: 79,
    name: "Noam",
    sex: "m",
  },
  {
    id: 80,
    name: "Shalom",
    sex: "f",
  },
  {
    id: 81,
    name: "Ester",
    sex: "f",
  },
  {
    id: 82,
    name: "Aharon",
    sex: "m",
  },
  {
    id: 83,
    name: "Ahuva",
    sex: "f",
  },
  {
    id: 84,
    name: "Shomron",
    sex: "m",
  },
  {
    id: 85,
    name: "David",
    sex: "m",
  },
  {
    id: 86,
    name: "Michal",
    sex: "m",
  },
  {
    id: 88,
    name: "Ahmed",
    sex: "m",
  },
  {
    id: 89,
    name: "Abdul",
    sex: "m",
  },
  {
    id: 90,
    name: "Ahmad",
    sex: "m",
  },
  {
    id: 91,
    name: "Noor",
    sex: "f",
  },
  {
    id: 92,
    name: "Wira",
    sex: "m",
  },
  {
    id: 93,
    name: "Malik",
    sex: "m",
  },
  {
    id: 96,
    name: "Hakim",
    sex: "m",
  },
  {
    id: 97,
    name: "Samar",
    sex: "m",
  },
  {
    id: 98,
    name: "Raniya",
    sex: "f",
  },
  {
    id: 99,
    name: "Nader",
    sex: "m",
  },
  {
    id: 100,
    name: "Bahar",
    sex: "f",
  },
  {
    id: 101,
    name: "Gibran",
    sex: "m",
  },
  {
    id: 102,
    name: "Alysia",
    sex: "f",
  },
  {
    id: 104,
    name: "Nadiyya",
    sex: "f",
  },
  {
    id: 105,
    name: "Najah",
    sex: "f",
  },
  {
    id: 106,
    name: "Basil",
    sex: "m",
  },
  {
    id: 107,
    name: "Yasmin",
    sex: "f",
  },
  {
    id: 109,
    name: "Salma",
    sex: "f",
  },
  {
    id: 111,
    name: "Rahim",
    sex: "m",
  },
  {
    id: 112,
    name: "Ibrahim",
    sex: "m",
  },
  {
    id: 113,
    name: "Samira",
    sex: "f",
  },
  {
    id: 114,
    name: "Sabir",
    sex: "m",
  },
  {
    id: 115,
    name: "Suhana",
    sex: "f",
  },
  {
    id: 116,
    name: "Rasheed",
    sex: "m",
  },
  {
    id: 117,
    name: "Osman",
    sex: "m",
  },
  {
    id: 118,
    name: "Irania",
    sex: "f",
  },
  {
    id: 120,
    name: "Rasheen",
    sex: "m",
  },
  {
    id: 121,
    name: "Estie",
    sex: "f",
  },
  {
    id: 122,
    name: "Armaan",
    sex: "m",
  },
  {
    id: 123,
    name: "Lela",
    sex: "f",
  },
  {
    id: 124,
    name: "Malikah",
    sex: "f",
  },
  {
    id: 125,
    name: "Gulzar",
    sex: "m",
  },
  {
    id: 126,
    name: "Maryam",
    sex: "f",
  },
  {
    id: 127,
    name: "Adrian",
    sex: "m",
  },
  {
    id: 128,
    name: "Blenda",
    sex: "f",
  },
  {
    id: 129,
    name: "Kasandra",
    sex: "f",
  },
  {
    id: 130,
    name: "Hubert",
    sex: "m",
  },
  {
    id: 131,
    name: "Deniel",
    sex: "m",
  },
  {
    id: 132,
    name: "Konrad",
    sex: "m",
  },
  {
    id: 133,
    name: "Mateusz",
    sex: "m",
  },
  {
    id: 134,
    name: "Leon",
    sex: "m",
  },
  {
    id: 135,
    name: "Kamila",
    sex: "f",
  },
  {
    id: 136,
    name: "Albin",
    sex: "m",
  },
  {
    id: 137,
    name: "Cezar",
    sex: "m",
  },
  {
    id: 138,
    name: "Gabriel",
    sex: "m",
  },
  {
    id: 139,
    name: "Maria",
    sex: "f",
  },
  {
    id: 141,
    name: "Ina",
    sex: "f",
  },
  {
    id: 142,
    name: "Eduard",
    sex: "m",
  },
  {
    id: 143,
    name: "Claudia",
    sex: "f",
  },
  {
    id: 144,
    name: "Paul",
    sex: "m",
  },
  {
    id: 145,
    name: "Ileana",
    sex: "f",
  },
  {
    id: 146,
    name: "Lucian",
    sex: "m",
  },
  {
    id: 147,
    name: "Aida",
    sex: "f",
  },
  {
    id: 149,
    name: "Fatoumata",
    sex: "f",
  },
  {
    id: 150,
    name: "Fatou",
    sex: "f",
  },
  {
    id: 151,
    name: "Musa",
    sex: "m",
  },
  {
    id: 152,
    name: "Mariama",
    sex: "f",
  },
  {
    id: 153,
    name: "Oumar",
    sex: "m",
  },
  {
    id: 154,
    name: "Agata",
    sex: "f",
  },
  {
    id: 156,
    name: "Aminata",
    sex: "f",
  },
  {
    id: 157,
    name: "Asante",
    sex: "f",
  },
  {
    id: 158,
    name: "Zakiyah",
    sex: "f",
  },
  {
    id: 159,
    name: "Kwasi",
    sex: "m",
  },
  {
    id: 160,
    name: "Jina",
    sex: "f",
  },
  {
    id: 163,
    name: "Kwanza",
    sex: "m",
  },
  {
    id: 164,
    name: "Imani",
    sex: "f",
  },
  {
    id: 165,
    name: "Milly",
    sex: "f",
  },
  {
    id: 166,
    name: "Saskia",
    sex: "f",
  },
  {
    id: 167,
    name: "Lyuba",
    sex: "f",
  },
  {
    id: 168,
    name: "Laszlo",
    sex: "m",
  },
  {
    id: 169,
    name: "Nika",
    sex: "f",
  },
  {
    id: 170,
    name: "Yana",
    sex: "f",
  },
  {
    id: 171,
    name: "Vlasta",
    sex: "f",
  },
  {
    id: 172,
    name: "Ivan",
    sex: "m",
  },
  {
    id: 173,
    name: "Milana",
    sex: "f",
  },
  {
    id: 174,
    name: "Marica",
    sex: "f",
  },
  {
    id: 175,
    name: "Marko",
    sex: "m",
  },
  {
    id: 176,
    name: "Petra",
    sex: "f",
  },
  {
    id: 177,
    name: "Arica",
    sex: "f",
  },
  {
    id: 178,
    name: "Zainab",
    sex: "f",
  },
  {
    id: 179,
    name: "Attila",
    sex: "f",
  },
  {
    id: 180,
    name: "Eren",
    sex: "f",
  },
  {
    id: 182,
    name: "Demir",
    sex: "m",
  },
  {
    id: 183,
    name: "Angus",
    sex: "m",
  },
  {
    id: 184,
    name: "Temür",
    sex: "m",
  },
  {
    id: 185,
    name: "Sulaiman",
    sex: "m",
  },
  {
    id: 186,
    name: "Ozella",
    sex: "f",
  },
  {
    id: 187,
    name: "Ismail",
    sex: "m",
  },
  {
    id: 188,
    name: "Fatima",
    sex: "f",
  },
  {
    id: 189,
    name: "Yunus",
    sex: "m",
  },
  {
    id: 190,
    name: "Sultana",
    sex: "f",
  },
  {
    id: 191,
    name: "Rahul",
    sex: "m",
  },
  {
    id: 192,
    name: "Kevin",
    sex: "m",
  },
  {
    id: 193,
    name: "Selina",
    sex: "f",
  },
  {
    id: 194,
    name: "Sofie",
    sex: "f",
  },
  {
    id: 195,
    name: "Arun",
    sex: "m",
  }
];
export default names;